import { BenefitFeatures } from "./BenefitFeatures";
import { ProductItem } from "./ProductItem";

export class CategoryProduct {
    constructor(public id: number, public category: string, public slug: string, public is_price: boolean, public short_description: string, public long_description: string, public background_image: string, public banner_products: string, public products: ProductItem[], public benefits: BenefitFeatures[]){}
}